<template>

  <div class="w-full flex justify-between items-center bg-lu-gray-dark px-4 py-4" v-if="(Array.isArray(contactLinks) && contactLinks.length) || feedback">
    <div v-if="Array.isArray(contactLinks) && contactLinks.length">
      <h3 class="text-white font-bold text-lg pb-1">Contact</h3>
      <a
        :href="link.link"
        class="border-dotted border-b hover:border-solid focus:border-solid focus:outline-none text-white"
        v-for="(link, index) in contactLinks" v-bind:key="index"
        :class="index > 0 ? 'mt-1 block' : ''"
      >{{ link.text }}</a>
    </div>
    <div>
      <a
        v-if="feedback"
        :href="feedback.link"
        class="bg-lu-red text-white rounded rounded-lg px-4 py-2 hover:underline"
      >{{ feedback.text }}</a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ContactFooter',
  props: {
    contactLinks: {
      type: Array,
      default: () => {
        return []
      }
    },
    feedback: {
      type: Object,
      default: () => {
        return null
      }
    }
  }
}
</script>

<style>
  /* purgecss start ignore */
  @tailwind  base;
  @tailwind  components;
  /* purgecss end ignore */

  @tailwind utilities;

</style>
